import settings from 'client/utils/settings';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/messaging';
import 'firebase/performance';

const config = {
  apiKey: settings.firebase.apiKey,
  authDomain: settings.firebase.authDomain,
  projectId: settings.firebase.projectId,
  storageBucket: settings.firebase.storageBucket,
  messagingSenderId: settings.firebase.messagingSenderId,
  appId: settings.firebase.appId,
};

firebase.initializeApp(config);

// Firefox Private Mode breaks persistence mode, see https://github.com/firebase/firebase-js-sdk/issues/801
// This is a way to detect private mode and not enable persistence in this case
if (navigator.serviceWorker) {
  firebase
    .firestore()
    .enablePersistence({ synchronizeTabs: true })
    .catch(() => {
      // Do nothing and live without persistence
    });
} else {
  // Do nothing and live without persistence
}

// Push notifications
if (firebase.messaging.isSupported()) {
  firebase.messaging().usePublicVapidKey(settings.firebase.messagingVapidKey);
}

// Performance monitoring
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const perf = firebase.performance();

if (settings.firebase.debugLogsEnabled) {
  firebase.firestore.setLogLevel('debug');
}

export default firebase;
